import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { store } from './store/store';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import './i18n'; // Инициализация i18n, если используется

// Создаем корневой элемент
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Рендерим приложение с провайдерами
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// Отчет о производительности
if (process.env.NODE_ENV === 'development') {
  reportWebVitals(console.log);
}
